module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_1_pc.baf0ac03.jpg";